import { defineMessages } from 'react-intl';

const messages = defineMessages({
  header: {
    description: 'branding defaults page header',
    defaultMessage: 'Branding Defaults',
    id: '9oRlhX',
  },
  headerDescription: {
    description: 'branding defaults description',
    defaultMessage:
      "You have {connectedStoreCount} of { totalStoreCount, plural, one {# store} other {# stores}} using the Branded Tracking Page. Go to <a>Store Setup</a> to switch the rest of your stores to ShipStation's Branded Tracking Page. The following stores are not connected:",
    id: '1lIZgc',
  },
  moreButton: {
    description: 'branding defaults more button',
    defaultMessage: 'More...',
    id: 'nYtXHf',
  },
  lessButton: {
    description: 'branding defaults less button',
    defaultMessage: 'Less...',
    id: 'YppEkH',
  },
  formDescription: {
    description: 'branding defaults form description',
    defaultMessage:
      'Branding Defaults set the default options used by your Branded Tracking Page and Branded Returns Portal. Re-engage your customers after their packages have shipped with tracking and returns pages customized with your store branding.',
    id: 'FrDSsS',
  },
  overrideMessage: {
    description: 'branding defaults override message',
    defaultMessage:
      'Each store can use these default settings or you can override the defaults with your store-specific branding settings.',
    id: '6vc0/7',
  },
  genericErrorTitle: {
    description: 'branding defaults error modal title',
    defaultMessage: 'Error',
    id: 't1Pu1V',
  },
  genericErrorMessage: {
    description: 'branding defaults error modal message',
    defaultMessage: 'Something went wrong, please try again.',
    id: 'sv4sop',
  },
  showStoreLogo: {
    description: 'branding defaults show store logo checkbox title',
    defaultMessage: 'Show Store Logo',
    id: '7lx8nv',
  },
  showStoreLogoDesc: {
    description: 'branding defaults show store logo checkbox description',
    defaultMessage: 'Configured for each store',
    id: 'lgtQLj',
  },
  customColors: {
    description: 'branding defaults show custom colors checkbox title',
    defaultMessage: 'Custom Colors',
    id: 'nc/6SY',
  },
  customColorsDesc: {
    description: 'branding defaults show custom colors checkbox description',
    defaultMessage: 'Use custom colors that match your brand',
    id: '5S3fr3',
  },
  showCustomTemplateLayout: {
    description: 'branding defaults show custom template layout checkbox title',
    defaultMessage: 'Change Your Template',
    id: 'U+xdtP',
  },
  showCustomTemplateLayoutDesc: {
    description: 'branding defaults show custom template layout checkbox description',
    defaultMessage: 'Pick from a gallery of templates that best fit your needs',
    id: '4QW2xD',
  },
  showCustomTemplateLayoutTitle: {
    description: 'branding defaults show custom template layout checkbox title',
    defaultMessage: 'Customize Design',
    id: 'KpH1+g',
  },
  showSocialLinks: {
    description: 'branding defaults show social media links checkbox title',
    defaultMessage: 'Show Social Media Links',
    id: 'RlU12Q',
  },
  showSocialLinksDesc: {
    description: 'branding defaults show social media links checkbox description',
    defaultMessage: 'For each social media profile that is configured for each store',
    id: 'eh99uS',
  },
  showServiceMenu: {
    description: 'branding defaults show service menu checkbox title',
    defaultMessage: 'Show Service Menu',
    id: 'Rur95R',
  },
  showOrderDetails: {
    description: 'branding defaults show order details checkbox title',
    defaultMessage: 'Show Order Details',
    id: 'hZQJ7F',
  },
  showOrderDetailsDesc: {
    description: 'branding defaults show order details checkbox desc',
    defaultMessage: 'Show items that were ordered - optionally include options, prices, SKUs, and images',
    id: 'GpSExl',
  },
  showPromoImage: {
    description: 'branding defaults show promo image checkbox title',
    defaultMessage: 'Show Promotional Image',
    id: 'yT4nGQ',
  },
  showPromoImageDesc: {
    description: 'branding defaults show promo image checkbox desc',
    defaultMessage: 'Add a popular product to increase upsell across your buyers',
    id: 'xxvX2U',
  },
  saveButton: {
    description: 'branding modal save button',
    defaultMessage: 'Save',
    id: '8enmW6',
  },
  cancelButton: {
    description: 'branding modal cancel button',
    defaultMessage: 'Cancel',
    id: 'EXjJmR',
  },
});

export default messages;
